import { render, staticRenderFns } from "./ManufacturingOriginDeclaration.vue?vue&type=template&id=39e4591e&"
import script from "./ManufacturingOriginDeclaration.vue?vue&type=script&lang=js&"
export * from "./ManufacturingOriginDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports